module.exports = __webpack_public_path__ + "media/newstyle/images/icon-mini-book-772f861b26e8a96e7dd3ed857387a27b.svg";